import { Close, FilterAltOutlined } from '@mui/icons-material';
import { Grid, Typography } from '@mui/material';

import React from 'react';
import { useTranslation } from 'react-i18next';

import { translations } from 'locales/i18n';

interface DrawerHeaderProps {
  onClose: () => void;
}
export const DrawerHeader = ({ onClose }: DrawerHeaderProps) => {
  const { t } = useTranslation();
  return (
    <Grid container alignItems={'center'} justifyContent={'space-between'} flexDirection={'row'}>
      <Grid container item xs alignItems={'center'}>
        <FilterAltOutlined />
        <Typography variant="h6">{t(translations.common.filter())}</Typography>
      </Grid>
      <Grid item onClick={onClose}>
        <Close />
      </Grid>
    </Grid>
  );
};
